import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
  FlatList,
} from 'react-native';
import {
  Text, ListItem, Button,
} from 'react-native-elements';
import langmap from 'langmap';
import Header from '../../components/misc/Header';

import styles from '../../styles';
import AORTypes from '../../types';
import { translate } from '../../locales/i18n';

class Settings extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Settings';

    this.handleAddLanguage = this.handleAddLanguage.bind(this);
    this.handleDelLanguage = this.handleDelLanguage.bind(this);

    this.state = {
    };
  }

  handleAddLanguage() {
    const { history } = this.props;

    history.push('/settings/addlang');
  }

  handleDelLanguage(lang) {
    const {
      userData, onUpdateUser, updateUserData,
    } = this.props;

    let langs;
    if (userData.langs) {
      langs = JSON.parse(userData.langs);
    } else {
      langs = [];
    }
    langs = langs.filter((item) => item !== lang);
    if (langs.length === 0) {
      langs = ['en'];
    }
    const newUserData = { ...userData, langs: JSON.stringify(langs) };

    onUpdateUser(newUserData)
      .then(() => {
        updateUserData();
      });
  }

  render() {
    const { userData, history, user } = this.props;

    console.log('render');
    console.log(userData);

    if (!userData) {
      console.log('no userData');

      return (
        <>
        </>
      );
    }

    let langs;
    if (userData.langs) {
      langs = JSON.parse(userData.langs);
    } else {
      langs = [];
    }

    if (langs.length === 0) {
      langs = ['en'];
    }
    langs.sort();

    console.log(langs);
    console.log(user.attributes);

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_settings')}
          hasCancel
          // can't use goBack as it goes back to adding language
          history={history}
        />

        <ScrollView
          style={{
            flex: 1,
            // ...(Platform.OS === 'web' ? {
            width: '80%',
            alignSelf: 'center',
            // } : {}),
          }}
        >
          <Text h4>{translate('settings_languages')}</Text>
          <Text
            style={{
              paddingTop: 20,
            }}
          >
            {translate('settings_languages_comment')}
          </Text>
          <View
            style={{
              paddingVertical: 20,
            }}
          >
            <FlatList
              data={langs}
              renderItem={({ item }) => (
                <ListItem bottomDivider>
                  {/* <Avatar
                    size="large"
                    rounded
                    source={{ uri: `https://www.countryflags.io/${item}/flat/64.png` }}
                  /> */}
                  <ListItem.Content>
                    <ListItem.Title>{langmap[item].nativeName}</ListItem.Title>
                    <ListItem.Subtitle>{langmap[item].englishName}</ListItem.Subtitle>
                  </ListItem.Content>
                  {langs.length > 1 && item !== user.attributes['custom:language'] && (
                    <Button
                      title={translate('button_delete')}
                      containerStyle={[styles.buttonfsf.secondaryContainer, { flex: 1 }]}
                      buttonStyle={[styles.buttonfsf.secondary]}
                      disabledStyle={[styles.buttonfsf.secondaryDisabled]}
                      titleStyle={styles.buttonfsf.secondaryTitle}
                      disabledTitleStyle={styles.buttonfsf.secondaryTitleDisabled}
                      onPress={() => this.handleDelLanguage(item)}
                    />
                  )}
                </ListItem>
              )}
            />
            {/* {langs.map((lang) => (
              <Text
                key={lang}
              >
                {langmap[lang].nativeName}
              </Text>
            ))}
            {langs.map((lang) => (
              <ListItem
                containerStyle={{
                  flex: 1,
                  width: '100%',
                  height: 100,
                  borderWidth: 1,
                  borderColor: 'blue',
                }}
                contentContainerStyle={{
                  flex: 1,
                  width: '100%',
                  height: 100,
                  borderWidth: 1,
                  borderColor: 'green',
                }}
                titleStyle={{
                  flex: 1,
                  width: '100%',
                  height: 100,
                  borderWidth: 1,
                  borderColor: 'yellow',
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: 'black',
                }}
                subtitleStyle={{
                  flex: 1,
                  width: '100%',
                  height: 100,
                  borderWidth: 1,
                  borderColor: 'purple',
                  fontSize: 12,
                  color: 'gray',
                }}
                key={lang}
                title={langmap[lang].nativeName}
                subtitle={langmap[lang].englishName}
                // leftAvatar={<Text>{langmap[lang].nativeName}</Text>}
                // rightAvatar={langs.length > 1 && lang !== userData.lang ? (
                //   <TouchableOpacity
                //     onPress={() => this.handleDelLanguage(lang)}
                //   >
                //     <Image
                //       style={{
                //         width: 24,
                //         height: 24,
                //       }}
                //       source={remove}
                //     />
                //   </TouchableOpacity>
                // ) : undefined}
                bottomDivider
                chevron
              />
            ))} */}
          </View>
          <View
            style={{
              flexDirection: 'row',
            }}
          >
            <Button
              title={translate('button_add')}
              containerStyle={[styles.buttonfsf.primaryContainer, { flex: 1 }]}
              buttonStyle={[styles.buttonfsf.primary, { width: 120 }]}
              disabledStyle={[styles.buttonfsf.primaryDisabled, { width: 120 }]}
              titleStyle={styles.buttonfsf.primaryTitle}
              disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
              onPress={this.handleAddLanguage}
              disabled={langs.length > 2}
              loadingProps={{ size: 'small', color: 'white' }}
            />
          </View>

          {/* <View
            style={{
              flexDirection: 'row',
            }}
          >
            <Button
              clear
              title={translate('button_close')}
              containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 40 }]}
              buttonStyle={styles.buttonfsf.secondary}
              titleStyle={styles.buttonfsf.secondaryTitle}
              // onPress={() => history.go(-1)}
              onPress={() => history.push('/ai-agents')}
            />
          </View> */}

        </ScrollView>
      </View>
    );
  }
}

Settings.defaultProps = {
  user: null,
  userData: null,
  updateUserData: () => null,
};

Settings.propTypes = {
  user: AORTypes.User,
  userData: AORTypes.User,
  onUpdateUser: PropTypes.func.isRequired,
  updateUserData: PropTypes.func,
  history: ReactRouterPropTypes.history.isRequired,
};

export default Settings;
